import type { Application } from '@src/@types/app';
import { CHANNELS } from '@src/constants/advertising';
import {
  DEFAULT_FILTERS,
  FILTERS_NAMES,
  FILTERS_SCHEME,
  MODES,
  SORT_BY_POSITION,
  SORT_BY_SEA_TRAFFIC,
} from '@src/constants/filters';
import { ListKeys } from '@src/constants/microcredits';
import { parse } from '@src/helpers/query';
import { CookieKey } from '@src/modules/cookie';
import { fetchOffers } from '@src/reducers/microcredits';
import { kzContextPageRoute } from '@src/shared/constants/pageRoutes';
import { getCookieFromServerOrClient } from '@src/utils/getCookieFromServerOrClient';
import { isKZMainPage } from '@src/utils/routing';

const CONTEXT_PAGES = [kzContextPageRoute];

export const getKazakhstanPageData = async (ctx: Application.ReduxNextPageContext) => {
  const {
    store: { dispatch },
    params: { locationRoute, pathname },
  } = ctx;

  const isContextPage = CONTEXT_PAGES.some((route) => pathname.startsWith(route));
  const isMainPage = isKZMainPage(pathname);

  const query = parse({
    defaultValues: {
      ...DEFAULT_FILTERS[MODES.KAZAKHSTAN],
      ...(isContextPage && {
        [FILTERS_NAMES.SORT]: SORT_BY_SEA_TRAFFIC,
        [FILTERS_NAMES.CHANNEL]: CHANNELS.KAZAKHSTAN_SEA,
      }),
      ...(isMainPage && {
        [FILTERS_NAMES.SORT]: SORT_BY_POSITION,
      }),
    },
    query: ctx.query,
    scheme: FILTERS_SCHEME,
  });

  const clientId = getCookieFromServerOrClient(ctx, CookieKey._ym_uid);

  const filterParams = {
    [FILTERS_NAMES.LOCATION]: locationRoute,
    [FILTERS_NAMES.ROUTE]: { asPath: ctx.asPath ?? '', query: ctx.query ?? {} },
    ...(Boolean(clientId) && {
      [FILTERS_NAMES.CLIENT_ID]: clientId,
    }),
  };

  return dispatch(fetchOffers({ key: ListKeys.KAZAKHSTAN, query, params: filterParams }));
};
